import type React from "react";

interface FieldProps {
	errors?: string | string[] | JSX.Element;
	validated_message?: string | JSX.Element;
	display?: "stacked" | "inline";
	children: string | JSX.Element | React.ReactNode;
}

export const Field = ({
	errors,
	validated_message = "",
	display = "stacked",
	children,
}: FieldProps) => {
	return (
		<div className="flex flex-col gap-2 w-full">
			{children}

			<div className={`flex ${display === "inline" && "sm:justify-end"}`}>
				<div className={`flex ${display === "inline" && "sm:w-2/3 sm:pl-2"}`}>
					{!!errors && (
						<span className="text-primary text-sm mb-2">
							{Array.isArray(errors) ? errors?.join(". ") : errors}
						</span>
					)}
					{!!validated_message && (
						<span className="text-positive-500 text-sm mb-1">
							{validated_message}
						</span>
					)}
				</div>
			</div>
		</div>
	);
};
